export enum AnimalKey {
  StudId = 'studId',
  IsMss = 'isMss',
  IsDna = 'isDna',
  SemenAvailable = 'semenAvailable',
  ForSale = 'forSale',
  SireInRefFlock = 'sireInRefFlock',
  SireInCpt = 'sireInCpt',
  IsRegistered = 'isRegistered',
  IsMlp = 'isMlp',
}
